import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Btn, Input, Page, Pill, Select, Table, fmt, sGet, sPost } from './staffShared';

const countdown = (iso) => {
  if (!iso) return '—';
  const ms = new Date(iso) - Date.now();
  if (ms <= 0) return 'expired';
  const h = Math.floor(ms / 3.6e6), m = Math.floor((ms % 3.6e6) / 6e4);
  return `${h} h ${m} min left`;
};

export default function ConsentGrantsPage() {
  const [rows, setRows] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState('');
  const [purpose, setPurpose] = useState('');
  const load = useCallback(() => sGet('/consent-grants').then(setRows).catch(e => toast.error(e.message)), []);
  useEffect(() => { load(); sGet('/customers').then(setTenants).catch(() => {}); }, [load]);
  const request = async () => {
    try { await sPost('/consent-grants', { tenant_id: tenantId, purpose }); toast.success('Consent requested — the customer admin must accept it'); setPurpose(''); load(); }
    catch (e) { toast.error(e.message); }
  };
  const revoke = async (g) => { try { await sPost(`/consent-grants/${g.id}/revoke`, {}); toast.success('Revoked'); load(); } catch (e) { toast.error(e.message); } };
  const name = (id) => tenants.find(t => t.id === id)?.legal_name || id.slice(0, 8);
  return (
    <Page title="Consent grants" sub="Customer data (journeys, telemetry, locations) opens to a staff user only while a grant is active — 24 h by default, 72 h max. Admin is not exempt." testId="consent-grants-page">
      <div className="rounded-lg border bg-white p-5 grid gap-3 md:grid-cols-3 items-end" style={{ borderColor: '#E5E3DC' }}>
        <Select label="Customer" value={tenantId} onChange={setTenantId} testId="consent-tenant" options={tenants.map(t => [t.id, t.legal_name])} />
        <Input label="Purpose" value={purpose} onChange={setPurpose} testId="consent-purpose" placeholder="Support ticket #…" />
        <Btn onClick={request} disabled={!tenantId || purpose.length < 3} testId="consent-request">Request consent</Btn>
      </div>
      <Table testId="consent-table" cols={['Customer', 'Purpose', 'Status', 'Requested', 'Expires', '']} rows={rows} render={g => (
        <tr key={g.id} className="border-t" style={{ borderColor: '#F3F1EA' }} data-testid={`consent-row-${g.id}`}>
          <td className="px-4 py-2 font-semibold">{name(g.tenant_id)}</td>
          <td className="px-4 py-2 text-xs">{g.purpose}</td>
          <td className="px-4 py-2"><Pill tone={g.status === 'active' ? 'ok' : g.status === 'requested' ? 'warn' : 'muted'}>{g.status}</Pill></td>
          <td className="px-4 py-2 text-xs">{fmt(g.requested_at)}</td>
          <td className="px-4 py-2 text-xs" data-testid={`consent-countdown-${g.id}`}>{g.status === 'active' ? countdown(g.expires_at) : fmt(g.expires_at)}</td>
          <td className="px-4 py-2 text-right">{['requested', 'active'].includes(g.status) && <button data-testid={`consent-revoke-${g.id}`} className="text-xs underline" style={{ color: '#B42318' }} onClick={() => revoke(g)}>Revoke</button>}</td>
        </tr>
      )} />
    </Page>
  );
}
